


// import React from "react";
// import "./About.css";

// const AboutPragyaPage = () => {
//   return (
//     <div className="about-wrapper" id="about">
      
//       {/* --- Decorative Background SVGs (Squiggles) --- */}
//       <svg className="svg-absolute svg-top-right" viewBox="0 0 844 513" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M183.757 -115.025C178.425 -109.692 167.771 -110.122 161.208 -107.579C111.814 -88.4478 58.3235 -44.3877 32.8214 1.97979C13.6502 36.8365 -1.64373 78.2347 6.01675 118.453C13.3873 157.148 47.5437 192.664 86.5372 200.462C129.428 209.04 171.61 186.059 209.286 168.552C239.763 154.389 269.854 138.786 301.4 127.068C325.897 117.97 351.422 110.291 375.751 123.877C405.498 140.489 407.597 169.079 393.196 196.952C360.65 259.943 302.383 306.364 269.49 369.8C255.521 396.74 245.461 426.42 272.894 449.363C291.577 464.989 315.618 470.22 339.586 468.722C382.719 466.026 432.118 455.623 469.887 434.259C519.425 406.237 568.122 365.066 628.588 385.542C675.981 401.592 656.669 439.21 656.669 477.232C656.669 506.718 665.212 513.202 695.493 505.632C752.94 491.27 800.667 439.038 832.602 391.605C834.9 388.191 860.782 357.887" stroke="#7E694C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
//         <path d="M265.744 -79.2202C229.396 -42.8729 190.321 -12.492 148.527 17.1491C128.309 31.4882 78.3135 88.0283 112.894 108.2C139.642 123.803 181.643 113.769 209.156 105.966C263.132 90.6599 314.848 70.7449 370.091 59.6963C403.76 52.9624 457.588 43.2622 483.16 74.1623C506.726 102.638 493.436 155.042 482.309 185.423C467.099 226.953 439.131 261.049 414.872 297.322C397.433 323.398 412.401 343.968 444.23 346.89C496.518 351.689 548.973 314.371 595.91 296.684C632.109 283.044 655.783 294.883 665.794 332.423C670.322 349.404 670.424 367.413 691.109 371.461C720.73 377.256 749.204 363.852 770.566 344.549C796.419 321.188 821.857 297.317 848.108 274.453C852.562 270.574 855.896 270.138 853.533 265.412" stroke="#7E694C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
//       </svg>

//       <svg className="svg-absolute svg-bottom-left" viewBox="0 0 826 474" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M642.409 831C647.736 823.927 658.38 824.497 664.938 821.125C714.286 795.752 767.727 737.317 793.205 675.822C812.359 629.593 827.638 574.688 819.985 521.349C812.621 470.029 778.497 422.926 739.539 412.583C696.688 401.206 654.545 431.685 616.904 454.904C586.455 473.687 556.392 494.382 524.875 509.922C500.401 521.99 474.899 532.173 450.593 514.154C420.874 492.123 418.777 454.205 433.165 417.238C465.68 333.696 523.893 272.13 556.756 187.998C570.712 152.268 580.762 112.905 553.355 82.4765C534.69 61.7529 510.67 54.8147 486.724 56.8015C443.631 60.3769 394.279 74.1737 356.544 102.509C307.052 139.672 258.4 194.276 197.99 167.119C150.641 145.833 169.935 95.9419 169.935 45.5159C169.935 6.40856 161.4 -2.19028 131.147 7.84982C73.7538 26.8969 26.0705 96.1709 -5.83442 159.078C-8.13075 163.606 -33.9891 203.798 -25.1754 203.798" stroke="#7E694C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
//         <path d="M552.344 795C588.679 746.836 627.739 706.579 669.517 667.301C689.727 648.301 739.703 573.38 705.136 546.65C678.398 525.974 636.414 539.271 608.911 549.61C554.956 569.892 503.259 596.282 448.038 610.922C414.382 619.845 360.575 632.699 335.012 591.753C311.455 554.02 324.74 484.58 335.863 444.322C351.067 389.291 379.024 344.111 403.274 296.045C420.706 261.493 405.744 234.235 373.928 230.363C321.66 224.004 269.225 273.454 222.306 296.891C186.12 314.965 162.456 299.277 152.449 249.532C147.922 227.031 147.82 203.167 127.143 197.804C97.5342 190.125 69.0704 207.886 47.7169 233.464C21.8739 264.42 -3.55393 296.051 -29.7956 326.349C-34.2472 331.489 -37.5805 332.067 -35.2182 338.329" stroke="#7E694C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
//       </svg>

//       {/* --- Main Content --- */}
//       <div className="about-container">
        
//         <div className="image-left-wrapper">
//           <img src="../images/about_2.jpg" alt="Pragya sitting" className="image-left" />
//         </div>

//         <div className="intro-text">
//           {/* --- SUN SVG IS NOW HERE --- */}
//           <svg className="svg-sun" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
//             {/* Center Circle */}
//             <circle cx="50" cy="50" r="18" stroke="#7E694C" strokeWidth="3" />
            
//             {/* Rays - Added more lines for a fuller look */}
//             <g stroke="#7E694C" strokeWidth="3" strokeLinecap="round">
//               <line x1="50" y1="20" x2="50" y2="10" />
//               <line x1="50" y1="80" x2="50" y2="90" />
//               <line x1="20" y1="50" x2="10" y2="50" />
//               <line x1="80" y1="50" x2="90" y2="50" />
              
//               <line x1="29" y1="29" x2="22" y2="22" />
//               <line x1="71" y1="71" x2="78" y2="78" />
//               <line x1="29" y1="71" x2="22" y2="78" />
//               <line x1="71" y1="29" x2="78" y2="22" />
              
//               {/* Additional Rays */}
//               <line x1="50" y1="25" x2="50" y2="22" opacity="0.5"/> 
//               <line x1="65" y1="35" x2="68" y2="32" />
//               <line x1="35" y1="65" x2="32" y2="68" />
//               <line x1="65" y1="65" x2="68" y2="68" />
//               <line x1="35" y1="35" x2="32" y2="32" />
//             </g>
//           </svg>
          
//           <span className="greeting">Namaste, everyone!</span>
//           <h1 className="title">Hey, I’m Pragya!</h1>
//           <p className="description">
//             From an engineering classroom to a yoga mat, I found myself seeking something deeper — stillness, clarity, healing. Yoga gave me that path. Slowly, it became more than a practice; it became a lifestyle.
//             <br /><br />
//             SatvicPath now brings together everything that helped me — soulful classes, mindful tools, and wisdom-rooted offerings — so you can walk your own satvic path, in your own way.
//             <br /><br />
//             Let’s walk it together.
//           </p>
//         </div>

//         <div className="image-right-wrapper">
//           <img src="../images/about_1.png" alt="Pragya in a yoga pose" className="image-right" />
//         </div>

//       </div>
//     </div>
//   );
// };

// export default AboutPragyaPage;



// import React from "react";
// import "./About.css";

// const AboutPragyaPage = () => {
//   return (
//     <div className="about-wrapper" id="about">
//       {/* Decorative SVGs - Placed in the main wrapper (UNTOUCHED) */}
//       {/* Top-Right Squiggle SVG */}
//       {/* <svg
//         className="svg-decor svg-top-right"
//         width="840"
//         height="280"
//         viewBox="0 0 844 513"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M183.757 -115.025C178.425 -109.692 167.771 -110.122 161.208 -107.579C111.814 -88.4478 58.3235 -44.3877 32.8214 1.97979C13.6502 36.8365 -1.64373 78.2347 6.01675 118.453C13.3873 157.148 47.5437 192.664 86.5372 200.462C129.428 209.04 171.61 186.059 209.286 168.552C239.763 154.389 269.854 138.786 301.4 127.068C325.897 117.97 351.422 110.291 375.751 123.877C405.498 140.489 407.597 169.079 393.196 196.952C360.65 259.943 302.383 306.364 269.49 369.8C255.521 396.74 245.461 426.42 272.894 449.363C291.577 464.989 315.618 470.22 339.586 468.722C382.719 466.026 432.118 455.623 469.887 434.259C519.425 406.237 568.122 365.066 628.588 385.542C675.981 401.592 656.669 439.21 656.669 477.232C656.669 506.718 665.212 513.202 695.493 505.632C752.94 491.27 800.667 439.038 832.602 391.605C834.9 388.191 860.782 357.887 851.961 357.887"
//           stroke="#7E694C"
//           strokeWidth="8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//         <path
//           d="M265.744 -79.2202C229.396 -42.8729 190.321 -12.492 148.527 17.1491C128.309 31.4882 78.3135 88.0283 112.894 108.2C139.642 123.803 181.643 113.769 209.156 105.966C263.132 90.6599 314.848 70.7449 370.091 59.6963C403.76 52.9624 457.588 43.2622 483.16 74.1623C506.726 102.638 493.436 155.042 482.309 185.423C467.099 226.953 439.131 261.049 414.872 297.322C397.433 323.398 412.401 343.968 444.23 346.89C496.518 351.689 548.973 314.371 595.91 296.684C632.109 283.044 655.783 294.883 665.794 332.423C670.322 349.404 670.424 367.413 691.109 371.461C720.73 377.256 749.204 363.852 770.566 344.549C796.419 321.188 821.857 297.317 848.108 274.453C852.562 270.574 855.896 270.138 853.533 265.412"
//           stroke="#7E694C"
//           strokeWidth="8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//         <path
//           d="M441.891 -129C427.958 -87.2035 368.932 -62.8876 334.459 -42.2038C308.807 -26.8124 277.736 -11.3537 258.3 12.1502C242.385 31.3961 287.64 23.0028 294.252 21.8297C370.325 8.33297 449.104 -40.5313 528.049 -15.3991C587.058 3.38669 591.757 69.1854 577.616 121.709C568.979 153.791 528.733 226.896 591.976 217.653C632.897 211.672 666.38 186.918 704.407 172.872C724.522 165.442 747.379 166.378 747.379 193.188C747.379 216.63 733.526 238.321 723.766 258.817C716.653 273.754 754.231 247.641 754.825 247.223C781.107 228.744 806.503 209.169 828.432 185.636C831.653 182.179 836.303 180.241 836.303 175.425"
//           stroke="#7E694C"
//           strokeWidth="8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg> */}

//       {/* Bottom-Left Squiggle SVG */}
//       {/* <svg
//         className="svg-bottom-left"
//         width="300"
//         height="384"
//         viewBox="0 0 826 474"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M642.409 831C647.736 823.927 658.38 824.497 664.938 821.125C714.286 795.752 767.727 737.317 793.205 675.822C812.359 629.593 827.638 574.688 819.985 521.349C812.621 470.029 778.497 422.926 739.539 412.583C696.688 401.206 654.545 431.685 616.904 454.904C586.455 473.687 556.392 494.382 524.875 509.922C500.401 521.99 474.899 532.173 450.593 514.154C420.874 492.123 418.777 454.205 433.165 417.238C465.68 333.696 523.893 272.13 556.756 187.998C570.712 152.268 580.762 112.905 553.355 82.4765C534.69 61.7529 510.67 54.8147 486.724 56.8015C443.631 60.3769 394.279 74.1737 356.544 102.509C307.052 139.672 258.4 194.276 197.99 167.119C150.641 145.833 169.935 95.9419 169.935 45.5159C169.935 6.40856 161.4 -2.19028 131.147 7.84982C73.7538 26.8969 26.0705 96.1709 -5.83442 159.078C-8.13075 163.606 -33.9891 203.798 -25.1754 203.798"
//           stroke="#7E694C"
//           strokeWidth="8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//         <path
//           d="M552.344 795C588.679 746.836 627.739 706.579 669.517 667.301C689.727 648.301 739.703 573.38 705.136 546.65C678.398 525.974 636.414 539.271 608.911 549.61C554.956 569.892 503.259 596.282 448.038 610.922C414.382 619.845 360.575 632.699 335.012 591.753C311.455 554.02 324.74 484.58 335.863 444.322C351.067 389.291 379.024 344.111 403.274 296.045C420.706 261.493 405.744 234.235 373.928 230.363C321.66 224.004 269.225 273.454 222.306 296.891C186.12 314.965 162.456 299.277 152.449 249.532C147.922 227.031 147.82 203.167 127.143 197.804C97.5342 190.125 69.0704 207.886 47.7169 233.464C21.8739 264.42 -3.55393 296.051 -29.7956 326.349C-34.2472 331.489 -37.5805 332.067 -35.2182 338.329"
//           stroke="#7E694C"
//           strokeWidth="8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//         <path
//           d="M376.159 861C390.083 805.616 449.071 773.395 483.521 745.987C509.157 725.592 540.209 705.108 559.632 673.963C575.537 648.461 530.31 659.583 523.703 661.137C447.679 679.021 368.951 743.771 290.056 710.469C231.085 685.576 226.389 598.387 240.521 528.788C249.153 486.276 289.373 389.406 226.17 401.654C185.275 409.579 151.813 442.38 113.811 460.992C93.7092 470.838 70.8664 469.598 70.8664 434.071C70.8664 403.009 84.7111 374.267 94.465 347.107C101.573 327.314 64.0193 361.917 63.4255 362.47C37.1603 386.958 11.7807 412.895 -10.1338 444.079C-13.3531 448.66 -18 451.228 -18 457.61"
//           stroke="#7E694C"
//           strokeWidth="8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg> */}

//       {/* Main content */}
//       <div className="about-container">
//         <div className="image-left-wrapper">
//           {/* UPDATED: Wrapped image in a frame container */}
//           <div className=" frame-left">
//             <img
//               src="../images/about_2.jpg"
//               alt="Pragya sitting"
//               className="about-image image-left"
//             />
//           </div>

//           {/* Decorative Sun SVG (UNTOUCHED) */}
//           {/* <svg
//             className="svg-sun"
//             width="509"
//             height="100"
//             viewBox="0 0 349 311"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
            
//           >
//             <path
//               d="M195.462 243.328C192.038 253.6 188.321 265.423 193.548 275.877"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M193.547 134.194C184.635 138.65 175.516 140.894 166.955 146.746C147.311 160.174 148.203 195.815 163.019 212.375C184.11 235.946 212.121 224.172 226.096 199.717C241.468 172.815 230.089 134.194 195.462 134.194"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M235.67 101.646C247.294 95.8339 258.59 84.8322 268.857 76.9687C274.644 72.5359 284.049 68.0705 287.365 61.439"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M254.816 118.877C265.163 113.704 276.809 110.753 287.365 105.475"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M268.219 159.084C289.302 169.626 321.722 164.828 344.804 164.828"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M270.133 197.377C258.716 197.377 290.334 208.057 300.767 212.694"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M237.584 218.438C237.584 233.169 243.625 250.156 247.157 264.283C250.07 275.933 251.874 290.61 258.645 300.767"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M149.512 237.584C131.395 255.701 120.463 284.722 107.391 306.51"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M105.476 233.755C96.1041 233.755 88.3518 238.151 80.5859 243.328"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M124.621 193.548C83.3918 193.548 44.5299 204.812 4 208.865"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M82.5 162.914H128.451"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M145.682 128.451C137.711 124.465 134.126 114.504 130.472 107.071C121.051 87.9104 108.761 66.9244 103.561 46.1221"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M172.488 113.134C179.429 99.2518 175.726 80.3067 178.232 65.2681"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//             <path
//               d="M210.779 101.646C220.945 71.1487 216.27 35.6463 224.182 4"
//               stroke="#ffae3cff"
//               strokeWidth="8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//           </svg> */}
//         </div>

//         <div className="intro-text">
//           <p className="greeting">Namaste, everyone!</p>
//           <h1 className="title">HEY, I’M PRAGYA!</h1>
//           <p className="description">
//             From an engineering classroom to a yoga mat, I found myself seeking
//             something deeper — stillness, clarity, healing. Yoga gave me that
//             path. Slowly, it became more than a practice; it became a lifestyle.
//             <br />
//             <br />
//             SatvicPath now brings together everything that helped me — soulful
//             classes, mindful tools, and wisdom-rooted offerings — so you can
//             walk your own satvic path, in your own way.
//             <br />
//             <br />
//             Let’s walk it together.
//           </p>
//           <button className="show-more-btn">Show more </button>
//         </div>

//         {/* UPDATED: Wrapped right image in a frame container */}
//         <div className=" frame-right">
//           <img
//             src="../images/save2.png"
//             alt="Pragya in a yoga pose"
//             className="about-image"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutPragyaPage;



import React, { useEffect } from "react";
import "./About.css";
import { Link } from "react-router-dom";
const AboutPragyaPage = () => {
  useEffect(() => {
    const observerOptions = { threshold: 0.1 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("ab-active");
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll(".ab-reveal");
    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="ab-wrapper" id="about">
      <div className="ab-container">
        {/* Left Image - Positioned higher */}
        <div className="ab-image-left-wrapper ab-reveal">
          <img
            src="../images/ab1.png"
            alt="Pragya sitting"
            className="ab-main-img ab-left-img"
          />
        </div>

        {/* Center Text Content */}
        <div className="ab-text-content ab-reveal">
          <p className="ab-script-text">Namaste, everyone!</p>
          <h2 className="ab-main-title">HEY, I’M PRAGYA!</h2>
          
          <div className="ab-description-box">
            <p className="ab-para">
              From an engineering classroom to a yoga mat, I found myself seeking
              something deeper — stillness, clarity, healing. Yoga gave me that
              path. Slowly, it became more than a practice; it became a lifestyle.
            </p>
            <p className="ab-para">
              SatvicPath now brings together everything that helped me — soulful
              classes, mindful tools, and wisdom-rooted offerings — so you can
              walk your own satvic path, in your own way.
            </p>
            <p className="ab-footer-note">Let's walk it together.</p>
          </div>

          <button className="ab-story-btn"><Link to="/About" style={{ textDecoration: 'none', color: "white" }}>
             MY STORY
            </Link></button>
        </div>

        {/* Right Image - Positioned lower, hidden on mobile */}
        <div className="ab-image-right-wrapper ab-reveal">
          <img
            src="../images/ab2.png"
            alt="Pragya yoga pose"
            className="ab-main-img ab-right-img"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutPragyaPage;